var map = {
	"./add.svg": "c2a3",
	"./backtotop.svg": "70bf",
	"./dashboard-clock.svg": "239f",
	"./dashboard-money-down.svg": "1275",
	"./dashboard-money-squre.svg": "d0f8",
	"./dashboard-money.svg": "bc45",
	"./dashboard-nodata.svg": "9c13",
	"./dashboard-nomessage.svg": "52e1",
	"./dashboard-notice.svg": "5512",
	"./dashboard-pie-bk.svg": "d273",
	"./dashboard-pie.svg": "acd9",
	"./dashboard-store.svg": "20ba",
	"./dashboard-xin.svg": "61f1",
	"./enlarge.svg": "5934",
	"./file.svg": "b8b2",
	"./login-captcha.svg": "1786",
	"./login-mobile.svg": "31c0",
	"./login-password.svg": "547e",
	"./login-user.svg": "2815",
	"./notice.svg": "fc99",
	"./reset-password-success.svg": "7cd5",
	"./role-debtor.svg": "3094",
	"./role-financing.svg": "c9b8",
	"./role-selected.svg": "7c52",
	"./sidebar-acceptor.svg": "8158",
	"./sidebar-active.svg": "7167",
	"./sidebar-auth.svg": "7521",
	"./sidebar-basic.svg": "6f88",
	"./sidebar-bill.svg": "cc63",
	"./sidebar-business.svg": "db4f",
	"./sidebar-check.svg": "3177",
	"./sidebar-coupon.svg": "073e",
	"./sidebar-customer-service.svg": "a919",
	"./sidebar-customer-yy.svg": "bff2",
	"./sidebar-customer.svg": "1011",
	"./sidebar-dashboard.svg": "fc40",
	"./sidebar-deal.svg": "0f45",
	"./sidebar-evaluate.svg": "c2fa",
	"./sidebar-home.svg": "edb8",
	"./sidebar-invoice-handling.svg": "c193",
	"./sidebar-invoice-search.svg": "0b33",
	"./sidebar-invoice-statistics.svg": "b86a",
	"./sidebar-invoice.svg": "32e8",
	"./sidebar-money.svg": "0a51",
	"./sidebar-order.svg": "e08c",
	"./sidebar-promotion.svg": "0583",
	"./sidebar-receipt.svg": "606a",
	"./sidebar-receivable.svg": "fce2",
	"./sidebar-registered.svg": "f158",
	"./sidebar-renovation.svg": "c8ad",
	"./sidebar-search.svg": "6744",
	"./sidebar-sign.svg": "f3e4",
	"./sidebar-upload.svg": "6b55",
	"./sidebar-warning.svg": "6d5e",
	"./sidebar-white-list.svg": "be17",
	"./sky.svg": "72ca",
	"./upload.svg": "9d82",
	"./warning.svg": "7e6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";